import { Injectable } from '@angular/core';
import { RaffleEvents } from '@core/models/raffle-events.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';

@Injectable()
export class RaffleEventsEntityService extends EntityCollectionServiceBase<RaffleEvents> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('RaffleEvents', serviceElementsFactory);
    }
}